/* eslint-disable @typescript-eslint/no-explicit-any */
import { Origin } from "@/constants/share";
import Login from "@/pages/Login";
import LoginModal from "@/sections/LoginModal";
import useShare from "@/sections/Share/useShare";
import useFetchSummary from "@/sections/Summary/useFetchSummary";
import Main from "@/sections/WebSummary/Main";
import { saveShare, saveShareForMeeting } from "@/services/share";
import AIQAStore from "@/store/AIQA.store";
import useLoginStore from "@/store/login.store";
import summaryCommonStore from "@/store/summaryCommon.store";
import formatOrigin from "@/utils/formatOrigin";
import { recordShare } from "@/utils/share";
import { message } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useShallow } from "zustand/react/shallow";
import ErrorPage from "../components/ErrorPage";
import PassWord from "../components/PassWord";
import LogoHeader from "./components/LogoHeader";
import ShareHeader from "./components/ShareHeader";
import WebExpire from "./components/WebExpire";
import "./index.less";

export default function ShareWeb() {
  const [showExpire, setShowExpire] = useState(true);
  const [showLogin, setShowLogin] = useState(false);
  const { loading, needPassword, viewableOrg, checkPassword, checkNeedPassword, shareType } = useShare();
  const [saving, setSaving] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const location = useLocation();
  const navigate = useNavigate();

  const toggleAIQAMode = AIQAStore((state) => state.toggleAIQAMode);

  const { shareInfo, streamId, origin, isOnlyOriginal } = summaryCommonStore(useShallow((state) => ({
    shareInfo: state.shareInfo,
    streamId: state.streamId,
    origin: state.origin,
    isOnlyOriginal: state.isOnlyOriginal
  })));
  const hasLogin = useLoginStore((state) => state.hasLogin);
  const [loginModalVisible, setLoginModalVisible] = useState(false);

  useFetchSummary(streamId, true);

  const showPassWordPage = needPassword && !shareInfo;

  const getShareInfo = async (password: string) => {
    const searchParams = new URLSearchParams(location.search);
    const shareId = searchParams.get("shareId");
    const streamId = searchParams.get("streamId");
    const origin = searchParams.get("origin") as Origin;
    const fileTransEnable = searchParams.get("fileTransEnable") || 'true'; // 是否经过二次转写，默认值为true
    if (password && streamId) {
      summaryCommonStore.getState().setShareInfo({
        streamId,
        shareId: shareId || "",
        password,
        origin,
        fileTransEnable: fileTransEnable === 'true'
      });
      summaryCommonStore.getState().setStreamId(streamId);
      if (hasLogin && formatOrigin(origin) === Origin.MAX_LINK) {
        await recordShare(searchParams.get("shareId")!);
        summaryCommonStore.getState().initStore();
        navigate(`/summary?streamId=${streamId}`, { replace: true });
      }
    }
  };

  const handleSave = async () => {
    if (useLoginStore.getState().hasLogin) {
      try {
        setSaving(true);
        messageApi.loading("保存中...", 0);
        const shareInfo = summaryCommonStore.getState().shareInfo;
        let newStreamId;
        if (shareInfo?.origin === Origin.MEETING_PLATE) {
          const res = await saveShareForMeeting({
            streamName: `live/${streamId}`
          });
          newStreamId = res.data?.replace('live/', '');
        } else {
          // const useComplete = shareInfo?.origin === Origin.MEETING_PLATE && shareInfo?.fileTransEnable;
          const res = await saveShare({
            streamName: `live/${streamId}`,
            contentStep: "SRC_DOC"
            // contentStep: useComplete ? "COMPLETE_DOC" : "SRC_DOC"
          });
          newStreamId = res.data?.replace('live/', '');
        }

        messageApi.destroy();
        // 清空 store, 防止从分享页保存到详情页时，在详情页接口还没返回时，详情页使用的还是分享页的数据，导致错误判断，
        summaryCommonStore.getState().initStore();
        navigate(`/summary?streamId=${newStreamId}`, { replace: true });
        message.success("已保存至AI会记");
        setLoginModalVisible(false);
      } catch (error: any) {
        messageApi.destroy();
        message.error("保存分享异常");
      } finally {
        setSaving(false);
      }
    } else {
      setLoginModalVisible(true);
    }
  };

  const handleFinishEnterPassword = (password: string) => {
    checkPassword(password, getShareInfo);
  };

  useEffect(() => {
    const showLogin = origin === Origin.MAX_LINK && !hasLogin;
    setShowLogin(showLogin);
    if (!needPassword && !showLogin) {
      getShareInfo("1234");
    }
  }, [needPassword, hasLogin, origin]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const origin = searchParams.get("origin");
    summaryCommonStore.getState().setOrigin(origin as Origin);
    return () => {
      summaryCommonStore.getState().setShareInfo(null);
      toggleAIQAMode(false, true);
    };
  }, []);

  return (
    <>
      {contextHolder}
      {loading || shareType ? (
        <ErrorPage viewableOrg={viewableOrg} loading={loading} shareType={shareType} checkNeedPassword={checkNeedPassword} />
      ) : (
        <>
          {!shareInfo && (
            <div className="w-full h-full bg-#f0f1f3">
              <LogoHeader />
              {showLogin && (
                <div className="login-page">
                  <div className="login-panel">
                    <Login onLoginSuccess={() => { }} />
                  </div>
                </div>
              )}
              {!showLogin && showPassWordPage && <PassWord fromsource={origin} onFinished={handleFinishEnterPassword} />}
            </div>
          )}

          {shareInfo && (
            <div className="bg-#F2F3F5 w-full h-full flex flex-col">
              <ShareHeader />
              {origin !== Origin.MAX_LINK && <WebExpire visible={showExpire} onClose={() => setShowExpire(false)} onSave={handleSave} saving={saving} />}
              <div className="flex-1 overflow-hidden"><Main hiddenSummary={isOnlyOriginal} /></div>
            </div>
          )}

          <LoginModal
            visible={loginModalVisible}
            onClose={() => {
              setLoginModalVisible(false);
            }}
            onLoginSuccess={() => {
              handleSave();
            }}
          />
        </>
      )}
    </>
  );
}
